module.exports = __webpack_public_path__ + "static/JulieJonakResume-34cd884e4ec564d56f4ca4594d1f2fe1.pdf";